import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
// import Glide from '@glidejs/glide';
// import { Player } from 'video-react';
import Footer from '../../components/Footer'
// import {Input, InputLabel, FormControl, Button} from "@material-ui/core";
import "video-react/dist/video-react.css";
import Button from '@material-ui/core/Button';

import "./public.css";
// import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";

let LoginLink = props => <Link to="./auth/login" {...props} />
let RegisterLink = props => <Link to="./auth/register" {...props} />

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  },
  input: {
    display: 'none'
  }
});

let Public = class Public extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      phone: "",
      registedMsg: 'hidden'
    };

    this.handleChange = prop => event => {
      this.setState({ [prop]: event.target.value });
    };

    this.handleMouseDownPassword = event => {
      event.preventDefault();
    };

    this.handleClickShowPassword = () => {
      this.setState({
        showPassword: !this.state.showPassword
      });
    };
  }

  render() {
    return <div>
      <div className="home-layout">
        <div className="home-brand">
          <div className="home-brand-logo"><img alt="Illumine Digital" src="./images/assets/logo-home.svg" width={100} /></div>
          <div className="home-brand-tagline">A Digital Learning Platform by Illumine</div>
        </div>
        <div className="home-card">
          <div className="home-hero"><img alt="" src="./images/assets/hero-img-pgm-home.svg" /></div>
          <div className="home-content">
            <div>
              <h1 className="home-title">Awakened Citizen Program - Digital Version</h1>
              <div><a className="home-site-link" href="http://theawakenedcitizen.org/"><img alt="" src="./images/assets/web-icon.svg" height={21.28} width="auto" /><span style={{ color: "#919191", fontSize: 14, paddingLeft: 6 }}>theawakenedcitizen.org</span></a></div>
              <div className="home-text">The Awakened Citizen Program material is available here exclusively for trained ACP teachers. Teachers can run sessions with their students in the classroom or remotely, using video conferencing tools.</div>
            </div>
            <div className="home-hosts">
              <div className="ch-sub-title" style={{ paddingBottom: 8, fontSize: 14 }}>Hosts:</div>
              <div className="home-hosts-row">
                <div style={{ display: "flex" }}>
                  <div><img alt="rkm" src="/images/assets/RKM.png" height={63} style={{ maxWidth: "100%" }} /></div>
                  <div style={{ fontSize: 12, width: 90, marginLeft: 16, display: "flex", alignItems: "center" }}>Delivered by Ramkrishna Mission,Delhi</div>
                </div>
                <div style={{ display: "flex", borderLeft: "1px solid #CFCFCF", paddingLeft: 16 }}>
                  <div><img alt="illumine-logo" src="https://s3.ap-south-1.amazonaws.com/illumine-logos/illuminelogo.svg" height={63} /></div>
                  <div style={{ fontSize: 12, width: 90, marginLeft: 16, display: "flex", alignItems: "center" }}>Knowledge Partner: ILLUMINE</div>
                </div>
              </div>
            </div>
            <div className="action-btn-cntr" style={{ width: "100%", textAlign: "center" }}>
              <Button classes={{ root: "btn-root-light", label: "btn-text" }} component={LoginLink} style={{ width: "50%" }}>Login</Button>
              <Button classes={{ root: "btn-root", label: "btn-text" }} component={RegisterLink} style={{ width: "50%" }}>Register</Button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  }
}

export default withStyles(styles)(Public)